/* eslint-disable */
/// This file is auto generated - do not edit manually
export const Articles = 'Website.SearchDialog.Articles';
export const Products = 'Website.SearchDialog.Products';
export const Brands = 'Website.SearchDialog.Brands';
export const ShowMore = 'Website.SearchDialog.ShowMore';
export const BrandFacetTitle = 'Website.SearchDialog.BrandFacetTitle';
export const TrendingQueries = 'Website.SearchDialog.TrendingQueries';
export const YourLatestQueries = 'Website.SearchDialog.YourLatestQueries';
export const ClearHistory = 'Website.SearchDialog.ClearHistory';
export const SearchSuggestions = 'Website.SearchDialog.SearchSuggestions';
export const ScopedProductGroupNamePrefix = 'Website.SearchDialog.ScopedProductGroupNamePrefix';
export const SectionTitleSubLine = 'Website.SearchDialog.SectionTitleSubLine';
export const RelatedToLatestSearch = 'Website.SearchDialog.RelatedToLatestSearch';
export const ResultSectionCaption = 'Website.SearchDialog.ResultSectionCaption';
export const TotalHitsLink = 'Website.SearchDialog.TotalHitsLink';
